import { render, staticRenderFns } from "./RoutingNewTargetRoute.vue?vue&type=template&id=49a7aa13"
import script from "./RoutingNewTargetRoute.vue?vue&type=script&lang=js"
export * from "./RoutingNewTargetRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports